// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Import = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Import = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Import = _exports.Import = function Import(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.045 16.2975C13.7608 16.6858 13.2558 16.875 12.5 16.875H5C3.68583 16.875 3.125 16.3142 3.125 15V5C3.125 3.68583 3.68583 3.125 5 3.125H9.375V5C9.375 7.015 10.485 8.125 12.5 8.125H14.375V10C14.375 10.345 14.655 10.625 15 10.625C15.345 10.625 15.625 10.345 15.625 10V7.5C15.625 7.33417 15.5592 7.175 15.4417 7.05833L10.4417 2.05833C10.3242 1.94083 10.1658 1.875 10 1.875H5C2.985 1.875 1.875 2.985 1.875 5V15C1.875 17.015 2.985 18.125 5 18.125H12.5C13.6658 18.125 14.5258 17.7592 15.0541 17.0358C15.2575 16.7575 15.1976 16.3667 14.9192 16.1625C14.6384 15.9575 14.25 16.02 14.045 16.2975ZM10.625 5V4.00917L13.4908 6.875H12.5C11.1858 6.875 10.625 6.31417 10.625 5ZM18.9583 13.3333C18.9583 13.6783 18.6783 13.9583 18.3333 13.9583H12.3425L12.9425 14.5583C13.1867 14.8025 13.1867 15.1983 12.9425 15.4425C12.8208 15.5642 12.6608 15.6258 12.5008 15.6258C12.3408 15.6258 12.1808 15.565 12.0591 15.4425L10.3925 13.7758C10.335 13.7183 10.2892 13.6492 10.2576 13.5725C10.1942 13.42 10.1942 13.2475 10.2576 13.095C10.2892 13.0183 10.335 12.9492 10.3925 12.8917L12.0591 11.225C12.3033 10.9808 12.6992 10.9808 12.9433 11.225C13.1875 11.4692 13.1875 11.865 12.9433 12.1092L12.3433 12.7092H18.3333C18.6783 12.7083 18.9583 12.9883 18.9583 13.3333Z",
      fill: "currentColor"
    }));
  };
});
